<template>
  <div class="mr-2">
    <v-btn
      icon
      color="white"
      @click="generateReport()"
    >
      <v-icon>mdi-file-pdf-box</v-icon>
    </v-btn>
    <vue-html2pdf
      ref="html2Pdf"
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="Formato médico"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      :html-to-pdf-options="options"
    >
      <section slot="pdf-content">
        <section class="pdf-item">
          <v-container class="margin">
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="6">
                    <img
                      src="@/assets/img/logo-puebla.png"
                      width="100%"
                      alt="img"
                    >
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DEPARTAMENTO MÉDICO Y TOXICOLÓGICO<br>Informe de evaluación médica</th>
                      </tr>
                    </thead>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DATOS PERSONALES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <v-container>
                          <v-row>
                            <v-col cols="9">
                              <v-row>
                                <v-col cols="6">
                                  Nombre: {{ getFullName(evaluacion.Derivacion.Programacion
                                    .Expediente.Personal) }}
                                </v-col>
                                <v-col cols="4">
                                  Edad:
                                  {{ getAge(evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.fechaNacimiento) }} años
                                </v-col>
                                <v-col cols="2">
                                  Sexo: {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.CatSexo.title }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Institución:
                                  {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.unidadAnalisisTactico }}
                                </v-col>
                                <v-col cols="4">
                                  Folio: {{ evaluacion.Derivacion.Programacion.Expediente.folio }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="8">
                                  Puesto: {{ evaluacion.Derivacion.Programacion.Expediente
                                    .Personal.unidadOperaciones }}
                                </v-col>
                                <v-col cols="4">
                                  RFC: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.Personal.rfc }}
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="6">
                                  Escolaridad:
                                </v-col>
                                <v-col
                                  v-if="evaluacion.Derivacion.Programacion.CatMotivoEvaluacion"
                                  cols="6"
                                >
                                  Motivo de evaluación: {{ evaluacion.Derivacion.Programacion
                                    .CatMotivoEvaluacion.title }}
                                </v-col>
                                <v-col
                                  v-else
                                  cols="6"
                                >
                                  Motivo de evaluación: NO REGISTRADO
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="7">
                                  Antigüedad: {{ evaluacion.Derivacion.Programacion
                                    .Expediente.antiguedadInstitucion }} años
                                </v-col>
                                <v-col cols="5">
                                  Fecha de evaluación:
                                  {{ getDate(evaluacion.Derivacion.Programacion
                                    .fechaEvaluacionPsicologica) }}
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3">
                              <img
                                :src="evaluacion.Derivacion.Programacion.Expediente.Personal.foto"
                                crossorigin="anonymous"
                                width="100%"
                                alt="testimg"
                              >
                            </v-col>
                          </v-row>
                        </v-container>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>FUNCIONES QUE DESEMPEÑA</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>DIAGNÓSTICOS ENCONTRADOS</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <v-container>
                            <v-row align="center">
                              <v-col
                                v-if="evaluacion.diabetesMellitusTipo2"
                                cols="12"
                              >
                                Diabetes
                              </v-col>
                              <v-col
                                v-if="evaluacion.dislipidemias"
                                cols="12"
                              >
                                Dislipidemias
                              </v-col>
                              <v-col
                                v-if="evaluacion.enfermedadesCardiovasculares"
                                cols="12"
                              >
                                Enfermedades cardiovasculares
                              </v-col>
                              <v-col
                                v-if="evaluacion.enfermedadesMuscoesYOsteonten"
                                cols="12"
                              >
                                Enfermedades osteotendinosas
                              </v-col>
                              <v-col
                                v-if="evaluacion.enfermedadesRespiratorias"
                                cols="12"
                              >
                                Enfermedades respiratorias
                              </v-col>
                              <v-col
                                v-if="evaluacion.enfermedadesSistemaNervioso"
                                cols="12"
                              >
                                Enfermedades del sistema nervioso
                              </v-col>
                              <v-col
                                v-if="evaluacion.enfermedadesTractuUrinario"
                                cols="12"
                              >
                                Enfermedades del tracto urinario
                              </v-col>
                              <v-col
                                v-if="evaluacion.hiperuricemia"
                                cols="12"
                              >
                                Hiperuricemia
                              </v-col>
                            </v-row>
                          </v-container>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>RECOMENDACIONES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td />
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
              <v-col cols="12">
                <v-simple-table class="font">
                  <template #default>
                    <thead>
                      <tr>
                        <th>TATUAJES</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <li
                            v-for="(tatuaje, index) in tatuajes"
                            :key="index"
                          >
                            <ul>
                              Zona:
                              {{
                                tatuaje.zona
                              }}
                              - Descripción:
                              {{
                                tatuaje.descripcion
                              }}
                            </ul>
                          </li>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </section>

        <div class="html2pdf__page-break" />
        <v-container class="margin">
          <v-row>
            <v-col cols="12">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>RESULTADO FINAL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ evaluacion.observaciones }}
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col
              cols="12"
              class="font"
            >
              Toda la información contenida en el presente documento está
              catalogada como RESERVADA Y CONFIDENCIAL de conformidad con la
              normatividad aplicable en los Artículos 3 Fracción II y 18 de la
              Ley Federal de Transparencia y Acceso a la Información Pública
              Gubernamental y por el Artículo 25 de la Ley de Acceso a la Información
              Pública y Protección de Datos Personales para el Estado de
              Morelos.
            </v-col>
            <v-col cols="6">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>ELABORÓ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr />
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                          >
                            Evaluador <br>
                            DMT07
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col cols="6">
              <v-simple-table class="font">
                <template #default>
                  <thead>
                    <tr>
                      <th>REVISÓ</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr />
                    <tr>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            align="center"
                          >
                            Jefe de departamento <br>
                            DMT07
                          </v-col>
                        </v-row>
                      </v-container>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
            <v-col
              cols="12"
              class="font mt"
            >
              Toda la información contenida en el presente documento
              está catalogada como CONFIDENCIAL de conformidad con la normatividad
              aplicable en los Artículos 3 Fracción II y 18 de la Ley Federal
              de Transparencia y Acceso a la Información Pública Gubernamental y
              por el Artículo 25 de la Ley de Acceso a la Información Pública
              y Protección de Datos Personales para el Estado de Morelos.
            </v-col>
          </v-row>
        </v-container>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import moment from 'moment';
import VueHtml2pdf from 'vue-html2pdf';

export default {
  components: {
    VueHtml2pdf,
  },

  props: {
    evaluacion: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      options: {
        image: {
          type: 'jpeg',
          quality: 0.98,
        },
        html2canvas: {
          scale: 2,
          useCORS: true,
          allowTaint: false,
        },
        margin: [8, 0, 8, 0],
      },
    };
  },

  computed: {
    tatuajes() {
      if (this.evaluacion) {
        if (this.evaluacion.descripcionTatuajes.length > 0) {
          return JSON.parse(this.evaluacionMedica.descripcionTatuajes);
        } return [];
      } return [];
    },
  },

  methods: {
    /*
            Generate Report using refs and calling the
            refs function generatePdf()
        */
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    getDate(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
  },
};
</script>

<style scoped>
    .font {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 12px;
    }
    th,
    tr {
        border: 1px solid;
    }
    .logo {
        border: 1px solid;
        height: 80px;
    }
    .mt {
        margin-top: 100px;
    }
    .margin {
        padding: 8px 48px 8px 48px;
    }
</style>
